import FullView from './FullView';
import WideView from './WideView';

export default ({ is360View = true, imageUrl }) => {
  const View = is360View ? FullView : WideView;
  return <View imageUrl={imageUrl} />;
};
